import { getBetAggr } from './getBetAggr';

export function getAggregationAndBetFromBetId(scomSogei, handicap) {
	let aggList = window.xs_ag.agsByBetId[`${scomSogei}_${handicap}`];
	if (!aggList && handicap != 0) {
		aggList = window.xs_ag.agsByBetId[`${scomSogei}_0`];
	}
	let market = getBetAggr(scomSogei, handicap);
	let aggregation = null;
	if (aggList) {
		let minorIndex = 0;
		let ranking = -1;
		for (let ka in aggList) {
			if (aggList[ka].ranking < ranking || ranking === -1) {
				minorIndex = ka;
				ranking = aggList[ka].ranking;
			}
		}
		aggregation = aggList[minorIndex];
		for (let ks in aggregation.scommesse) {
			const bet = aggregation.scommesse[ks];
			if (bet.id === scomSogei && bet.handicap == handicap) {
				market = bet;
				break;
			}
		}
	}
	
	return {
		market,
		aggregation
	};
}
window.getAggregationAndBetFromBetId = getAggregationAndBetFromBetId;
